<template>
  <div class="mb-1">
    <b-card class="m-1 border-0" bg-variant="light" body-class="p-0 d-flex">
      <span
        class="item-handle d-flex align-items-center bg-secondary py-2 px-3 cursor-pointer rounded"
        @click="toggleEditing"
      >
        <font-awesome-icon icon="sort" fixed-width size="lg" class="text-muted"/>
      </span>

      <div class="p-2 w-100">
        <b-row no-gutters class="align-items-center">
          <b-col class="mb-2 mb-md-0">
            {{ this.$t('widgetAreas.typeWidget', {type: this.$t('widgetAreas.types.' + item.type)}) }}
            <small v-if="title" class="text-muted" :class="{'ml-1': $dir.ltr, 'mr-1': $dir.rtl}">
              ({{ title }})
            </small>
          </b-col>

          <b-col md="auto" class="text-center">
            <b-btn
              variant="outline-info"
              size="sm"
              class="border-0"
              @click="toggleEditing"
              :title="$t('shared.edit')"
              v-b-tooltip.hover
            >
              <font-awesome-icon :icon="editing ? 'times' : 'pen'" fixed-width class="align-middle m-1"/>
            </b-btn>

            <b-btn
              variant="outline-danger"
              size="sm"
              class="mx-1 border-0"
              @click="emitRemove"
              :title="$t('shared.remove')"
              v-b-tooltip.hover
            >
              <font-awesome-icon icon="trash-alt" fixed-width class="align-middle m-1"/>
            </b-btn>
          </b-col>
        </b-row>

        <div v-show="editing">
          <hr class="my-2"/>
          <component ref="widget" :is="getWidgetName(item)" :widget="item" @setTitle="setTitle"/>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "Item",
  components: {
    BrandsWidget: () => import('./widgets/Brands'),
    ComponentWidget: () => import('./widgets/Component'),
    HeaderWidget: () => import('./widgets/Header'),
    ItemsWidget: () => import('./widgets/items'),
    NavWidget: () => import('./widgets/Nav'),
    PostsWidget: () => import('./widgets/Posts'),
    ProductCategoriesWidget: () => import('./widgets/ProductCategories'),
    ProductGroupsWidget: () => import('./widgets/ProductGroups'),
    ProductsWidget: () => import('./widgets/products'),
    SliderWidget: () => import('./widgets/slider'),
    TextWidget: () => import('./widgets/Text')
  },
  props: {
    item: Object
  },
  data () {
    return {
      editing: this.item.id < 0 ? true : false,
      title: this.item.title
    }
  },
  methods: {
    toggleEditing () {
      this.editing = !this.editing
    },
    emitRemove () {
      if (confirm(this.$t('shared.areYouSureToRemoveThisItem'))) {
        this.$emit('remove', this.item)
      }
    },
    setTitle (title) {
      this.title = title
    },
    getWidgetName (item) {
      return `${item.type}Widget`
    },
    validateAll () {
      const validates = this.$refs.widget.validateAll()
      return validates.then(isValid => {
        if (!isValid) {
          this.editing = true
        }
        return isValid
      })
    }
  }
}
</script>

<style>
.drag-area {
  min-height:50px;
}
</style>
